import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';

export type PendingBookingResponse = {
  id: number;
  providerName: string;
  providerUUID: string;
  providerId: number;
  providerDomain: string;
  manualCheckInIsAllowed: boolean;
  manualLateCancellationIsAllowed: boolean;
  manualNoShowIsAllowed: boolean;
  deletedDate: string | null;
  createdDate: string;
};

export const useRequestPendingBookingsSettings = () => {
  const { currentProvider } = useProvider();

  return useQuery<PendingBookingResponse, IErrorResponse>(
    [REQUEST_ACTIONS.CUSTOMER_LIST],
    () =>
      requestReactQuery<PendingBookingResponse>({
        url: routeReplacer(CORE_SERVICE_URLS.PENDING_BOOKINGS_SETTINGS, {
          domain: currentProvider?.domain || '',
        }),
        config: { method: 'GET' },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
    },
  );
};
